export const M1_UNIT_2 = {
  id: "u2-countries",
  title: "Unidad 2: World Traveler",
  topic: "Countries, Nationalities & Origins",
  iconType: "globe",
  grammarImage: "/u2-countries.jpg",
  grammarText:
    "Diferencia clave: 'I am from [Country]' (Soy de...) vs 'I am [Nationality]' (Soy...).",
  sets: [
{
 id: "u2-set1",
title: "Set 1: Landing in New York",
context: `*Aeropuerto JFK - Control de Pasaportes*


María acaba de aterrizar en Nueva York. Es su primer viaje internacional.
El oficial de inmigración revisa su pasaporte mexicano.
"Buenas tardes. De donde eres?" - pregunta amablemente.


*JFK Airport - Passport Control*


Maria has just landed in New York. It's her first international trip.
The immigration officer checks her Mexican passport.
"Good afternoon. Where are you from?" - he asks kindly.`,
  
  questions: [
    // Q1: MATCH - Introduce countries + nationalities
    {
      type: "match",
      q: "The officer checks passports. Match each country to its nationality.",
      pairs: [
        { left: "USA", right: "American" },
        { left: "Mexico", right: "Mexican" },
        { left: "Canada", right: "Canadian" }
      ],
      a: "completed",
      tip: "Country (noun) → Nationality (adjective).",
      successTip: "USA → American, Mexico → Mexican, Canada → Canadian. Notice the pattern: -an or -ian endings! 🌎"
    },
    
    // Q2: MC - "from + country" (CORREGIDO)
    {
      type: "mc",
      q: "Officer: 'Where are you from?' María answers: 'I am ___ Mexico.'",
      options: ["from", "in", "to"],
      a: "from",
      tip: "'Where are you FROM?' requires 'from' in the answer.",
    },
    {
      type: "mc",
      q: "Immigration form: 'Nationality?' María writes: 'I am ___.'",
      options: ["Mexican", "from Mexico", "Mexico"],
      a: "Mexican",
      tip: "On forms, write only nationality (no 'from').",
    },
    {
      type: "order",
      q: "Traduce: 'Soy de Colombia.'",
      words: ["I", "am", "from", "Colombia."],
      a: "I am from Colombia.",
      extra: ["Colombian", "the"],
      tip: "'I am from' + country (no article before country).",
      successTip: "'I am from Colombia' = origin. 'I am Colombian' = nationality. Two ways! Both correct! 🇨🇴"
    },
    {
      type: "mc",
      q: "A traveler says: 'I am from Canada, so I'm ___.'",
      options: ["Canadian", "Canada", "from Canada"],
      a: "Canadian",
      tip: "'So I'm...' requires nationality (adjective), not country.",
      successTip: "Canada → Canadian. 'So' = 'entonces/así que'. Pattern: I'm from [country], so I'm [nationality]! 🍁"
    },
    {
      type: "input",
      q: "Officer: 'Where are you from?' 'I'm from Brazil, so I am ___.'",
      a: "Brazilian",
      alts: ["brazilian"],
      tip: "BraZILian! Common mistake: 'Brasilian' ❌. Remember the 'z': BraZILian ✅.",
    },
    {
      type: "match",
      q: "Match each famous landmark to its country.",
      pairs: [
        { left: "🗽 Statue of Liberty", right: "USA" },
        { left: "🍁 CN Tower", right: "Canada" },
        { left: "🏛️ Chichen Itza", right: "Mexico" }
      ],
      a: "completed",
      successTip: "Statue = estatua. Liberty = libertad. Tower = torre. Learn landmarks to talk about countries! 🗽🍁🏛️"
    },
    {
      type: "order",
      q: "Traduce la pregunta del oficial: '¿De dónde eres?'",
      words: ["Where", "are", "you", "from?"],
      a: "Where are you from?",
      extra: ["What", "country"],
      tip: "Standard immigration question.",
      successTip: "THE question! 🛂 'Where are you from?' = '¿De dónde eres?' Usualmente puedes escuchar: 'Where you from?' (drop 'are'). Super common! 🗣️"
    },
    {
      type: "mc",
      q: "A traveler from Buenos Aires says: 'I am from Argentina, so I'm ___.'",
      options: ["Argentinian", "Argentina", "Argent"],
      a: "Argentinian",
      tip: "Argentina → Argentinian (also 'Argentine' in UK English).",
      successTip: "Argentina → Argentinian (US) or Argentine (UK). Both correct! 🇦🇷 Pattern: -ian ending!"
    },
    {
      type: "input",
      q: "Officer: 'What's your nationality?' 'I am from the USA. I am ___.'",
      a: "American",
      alts: ["american"],
      tip: "USA → American (not 'US' as nationality).",
      successTip: "USA = United States of America. Nationality: American 🇺🇸. Slang: 'Yank' or 'Yankee' (informal, sometimes offensive in the South!). Casual: 'I'm from the States' 🗽"
    }
  ]
},
// ===================================================================
// SET 2: EUROPE (A1.0)
// ===================================================================
{
  id: "u2-set2",
  title: "Set 2: European Travelers",
  context: `*Hotel Lobby - Londres*

Carlos hace check-in en su hotel. Hay viajeros de toda Europa.
"Hola, soy de España," dice un hombre joven.
"Y yo soy británico," responde el recepcionista con una sonrisa.

*Hotel Lobby - London*

Carlos checks in at his hotel. There are travelers from all over Europe.
"Hello, I'm from Spain," says a young man.
"And I'm British," replies the receptionist with a smile.`,
  
  questions: [
    {
      type: "match",
      q: "Match each European country to its nationality.",
      pairs: [
        { left: "Spain", right: "Spanish" },
        { left: "UK", right: "British" },
        { left: "France", right: "French" }
      ],
      a: "completed",
      tip: "Notice the -ish ending pattern.",
      successTip: "-ish endings: Spanish, British, Irish, Polish, Turkish. Easy pattern! 🇪🇸🇬🇧🇫🇷"
    },
    
    {
      type: "mc",
      q: "Receptionist: 'Welcome to London!' Carlos: 'Thank you. I am ___ Mexico.'",
      options: ["from", "in", "to"],
      a: "from",
      tip: "'I am FROM [country]' = origin."
    },
    
    {
      type: "input",
      q: "A traveler says: 'I'm from Madrid, Spain. I am ___.' (nationality)",
      a: "Spanish",
      alts: ["spanish"],
      tip: "Spain → Spanish (same word for language AND nationality).",
      successTip: "Spanish works for BOTH language and nationality! Same as French, English, Chinese. Convenient! 🇪🇸"
    },
    
    {
      type: "order",
      q: "Traduce: 'Ella es de Francia.'",
      words: ["She", "is", "from", "France."],
      a: "She is from France.",
      extra: ["French", "the"],
      tip: "She is from + country name."
    },
    
    {
      type: "mc",
      q: "A guest from Paris says: 'I am from France, so I'm ___.'",
      options: ["French", "France", "from France"],
      a: "French",
      tip: "'So I'm...' needs nationality, not country."
    },
    
    {
      type: "input",
      q: "Guest: 'I live in Berlin, Germany. I am ___.' (nationality)",
      a: "German",
      alts: ["german"],
      tip: "Germany → German (no -y in nationality)."
    },
    
    {
      type: "match",
      q: "Match each capital city to its country.",
      pairs: [
        { left: "Madrid", right: "Spain" },
        { left: "London", right: "UK" },
        { left: "Paris", right: "France" }
      ],
      a: "completed",
      successTip: "Capital = capital (same word!). Madrid = capital OF Spain. Use 'of' to show possession! 🏛️"
    },
    
    {
      type: "mc",
      q: "Hotel form: 'Country of origin?' Guest from Rome writes: '___'",
      options: ["Italy", "Italian", "from Italy"],
      a: "Italy",
      tip: "Forms ask for country name only (no 'from').",
      successTip: "Forms are SHORT! Country: Italy ✅. Nationality: Italian ✅. Origin: from Italy ❌ (too long for forms). 📝"
    },
    
    {
      type: "input",
      q: "Guest: 'I'm from Rome, Italy. I am ___.' (nationality)",
      a: "Italian",
      alts: ["italian"],
      tip: "Italy → Italian (-ian ending)."
    },
    
    {
      type: "order",
      q: "Traduce la pregunta del recepcionista: '¿De qué país eres?'",
      words: ["What", "country", "are", "you", "from?"],
      a: "What country are you from?",
      extra: ["Where", "which"],
      tip: "Alternative to 'Where are you from?'",
      successTip: "'What country are you from?' = more specific than 'Where are you from?' Both correct! Use 'What country' when you need exact name. 🌍"
    }
  ]
},

// ===================================================================
// SET 3: ASIA & OCEANIA (A1.0)
// ===================================================================
{
  id: "u2-set3",
  title: "Set 3: Asian Explorers",
  context: `*Cafetería del Hotel*

Carlos desayuna con huéspedes de Asia y Oceanía.
"Soy de Tokio, Japón," dice una mujer.
"¡Yo soy australiano!" responde un hombre alto.

*Hotel Café*

Carlos has breakfast with guests from Asia and Oceania.
"I'm from Tokyo, Japan," says a woman.
"I'm Australian!" replies a tall man.`,
  
  questions: [
    {
      type: "match",
      q: "Match each Asian country to its nationality.",
      pairs: [
        { left: "Japan", right: "Japanese" },
        { left: "China", right: "Chinese" },
        { left: "India", right: "Indian" }
      ],
      a: "completed",
      tip: "Notice -ese endings for East Asian countries.",
      successTip: "-ese pattern: Japanese, Chinese, Vietnamese, Portuguese. Mostly Asia + Portugal! 🇯🇵🇨🇳"
    },
    
    {
      type: "mc",
      q: "Guest: 'I'm from Tokyo, so I'm ___.'",
      options: ["Japanese", "Japan", "from Japan"],
      a: "Japanese",
      tip: "Tokyo is in Japan."
    },
    
    {
      type: "input",
      q: "Guest: 'I'm from Beijing, China. I am ___.' (nationality)",
      a: "Chinese",
      alts: ["chinese"],
      tip: "China → Chinese (same for language and nationality)."
    },
    
    {
      type: "order",
      q: "Traduce: 'Él es de la India.'",
      words: ["He", "is", "from", "India."],
      a: "He is from India.",
      extra: ["Indian", "the"],
      tip: "India (no article in English).",
      successTip: "In English: 'India' (no 'the') ✅. In Spanish: 'la India' ✅. Drop 'the' in English! Same with Japan, China, Mexico. 🌏"
    },
    
    {
      type: "mc",
      q: "A traveler from Mumbai says: 'I am from India, so I'm ___.'",
      options: ["Indian", "India", "Hindu"],
      a: "Indian",
      tip: "Hindu is a religion, not a nationality.",
      successTip: "Indian = nationality 🇮🇳. Hindu = religion 🕉️. Common mistake! India has Hindus, Muslims, Christians, Sikhs, etc. Don't confuse! ⚠️"
    },
    
    {
      type: "input",
      q: "Guest: 'I'm from Sydney, Australia. I am ___.' (nationality)",
      a: "Australian",
      alts: ["australian"],
      tip: "Australia → Australian (-ian ending)."
    },
    
    {
      type: "match",
      q: "Match each city to its country.",
      pairs: [
        { left: "Tokyo", right: "Japan" },
        { left: "Beijing", right: "China" },
        { left: "Sydney", right: "Australia" }
      ],
      a: "completed",
      tip: "These are major cities but not all are capitals."
    },
    
    {
      type: "mc",
      q: "Guest: 'Where are you from?' Carlos: 'I am ___ Mexico.'",
      options: ["from", "in", "of"],
      a: "from",
      tip: "Always 'from' after 'I am' for origin."
    },
    
    {
      type: "input",
      q: "Guest: 'I'm from Auckland, New Zealand. I am a ___.' (informal nationality)",
      a: "Kiwi",
      alts: ["kiwi", "New Zealander"],
      tip: "Kiwi = informal name for New Zealanders.",
      successTip: "Kiwi 🥝 = New Zealander (informal/friendly). Official: New Zealander. Kiwi is also a bird AND a fruit! Context matters! 🇳🇿"
    },
    
    {
      type: "order",
      q: "Traduce: 'Nosotros somos de Japón.'",
      words: ["We", "are", "from", "Japan."],
      a: "We are from Japan.",
      extra: ["Japanese", "the"],
      tip: "We are from + country.",
      successTip: "'We are from Japan' OR 'We are Japanese' - both work! Mix them: 'We're Japanese. We're from Tokyo.' Natural! 🇯🇵"
    }
  ]
},

// ===================================================================
// SET 4: FROM vs NATIONALITY (A1+)
// ===================================================================
{
  id: "u2-set4",
  title: "Set 4: Grammar Class",
  context: `*Salón de Clases - Escuela de Inglés*

La profesora explica la diferencia entre país y nacionalidad.
"I am FROM Mexico. I am Mexican," escribe en el pizarrón.
Carlos finalmente entiende la diferencia.

*Classroom - English School*

The teacher explains the difference between country and nationality.
"I am FROM Mexico. I am Mexican," she writes on the board.
Carlos finally understands the difference.`,
  
  questions: [
    {
      type: "match",
      q: "Match each pattern to its example.",
      pairs: [
        { left: "I am from...", right: "Canada" },
        { left: "I am...", right: "Canadian" },
        { left: "I speak...", right: "English" }
      ],
      a: "completed",
      tip: "Three different structures.",
      successTip: "'FROM' = country. NO 'from' = nationality. Pattern: I'm FROM Canada (origin), I'm Canadian (identity). Master this! 🎯"
    },
    
    {
      type: "mc",
      q: "Which is correct? 'I am ___ Spain.'",
      options: ["from", "Spanish", "a Spanish"],
      a: "from",
      tip: "After 'I am', use 'from' before a country."
    },
    
    {
      type: "mc",
      q: "Which is correct? 'I am ___.' (nationality only)",
      options: ["Spanish", "from Spain", "Spain"],
      a: "Spanish",
      tip: "Nationality doesn't need 'from'.",
      successTip: "NO 'from' with nationality! I am Spanish ✅, I am from Spain ✅, I am from Spanish ❌. Keep them separate! 🚫"
    },
    
    {
      type: "order",
      q: "Traduce: '¿De dónde es ella?'",
      words: ["Where", "is", "she", "from?"],
      a: "Where is she from?",
      extra: ["What", "country"],
      tip: "Question form with 'she'."
    },
    
    {
      type: "input",
      q: "Teacher: 'Tell me your origin AND nationality.' Carlos: 'I am ___ Mexico. I am Mexican.'",
      a: "from",
      tip: "Origin needs 'from'."
    },
    
    {
      type: "mc",
      q: "Error correction: 'I am from French.' What's wrong?",
      options: ["Should be 'I am from France'", "Should be 'I am French'", "Both A and B"],
      a: "Both A and B",
      tip: "'From' needs a country, not a nationality.",
      successTip: "'I am from French' ❌ → 'I am from France' ✅ OR 'I am French' ✅. Never mix 'from' + nationality! Common beginner mistake! ⚠️"
    },
    
    {
      type: "input",
      q: "Form asks: 'Country?' You write: ___. 'Nationality?' You write: Mexican.",
      a: "Mexico",
      alts: ["mexico"],
      tip: "Country = Mexico, Nationality = Mexican."
    },
    
    {
      type: "order",
      q: "Traduce: 'Ellos son alemanes.'",
      words: ["They", "are", "German."],
      a: "They are German.",
      extra: ["from", "Germany"],
      tip: "Nationality only (no 'from').",
      successTip: "Plural nationalities DON'T add 's' in English! They are German ✅, They are Germans ❌. Exception: as nouns ('two Germans' ✅). As adjectives: no 's'! 📚"
    },
    
    {
      type: "mc",
      q: "Which sentence is grammatically WRONG?",
      options: ["I am from Italy", "I am Italian", "I am from Italian"],
      a: "I am from Italian",
      tip: "'From' + country, NOT nationality."
    },
    
    {
      type: "match",
      q: "Match the question to its correct answer.",
      pairs: [
        { left: "Where are you from?", right: "I am from Canada" },
        { left: "What's your nationality?", right: "I am Canadian" },
        { left: "What country?", right: "Canada" }
      ],
      a: "completed",
      successTip: "Three questions, three different answers! Master all three: 'Where from?' → from Canada. 'Nationality?' → Canadian. 'What country?' → Canada. Interview ready! 🎤"
    }
  ]
},

// ===================================================================
// SET 5: LANGUAGES (A1+)
// ===================================================================
{
  id: "u2-set5",
  title: "Set 5: Language Exchange",
  context: `*Intercambio de Idiomas - Parque*

Carlos practica inglés con estudiantes internacionales.
"¿Hablas español?" pregunta una chica francesa.
"Sí, y estoy aprendiendo inglés," responde Carlos.

*Language Exchange - Park*

Carlos practices English with international students.
"Do you speak Spanish?" asks a French girl.
"Yes, and I'm learning English," Carlos replies.`,
  
  questions: [
    {
      type: "match",
      q: "Match each country to its main language.",
      pairs: [
        { left: "Mexico", right: "Spanish" },
        { left: "USA", right: "English" },
        { left: "France", right: "French" }
      ],
      a: "completed",
      tip: "Country → Language.",
      successTip: "Some nationalities = languages! Spanish, French, English, Chinese work for BOTH. Convenient! 🗣️"
    },
    
    {
      type: "mc",
      q: "Student asks: 'Do you ___ English?'",
      options: ["speak", "talk", "say"],
      a: "speak",
      tip: "'Speak' is used for languages.",
      successTip: "SPEAK a language ✅. TALK to a person ✅. SAY words/phrases ✅. Don't mix! 'I speak English' (not 'I talk English' ❌). 🗨️"
    },
    
    {
      type: "order",
      q: "Traduce: '¿Hablas francés?'",
      words: ["Do", "you", "speak", "French?"],
      a: "Do you speak French?",
      extra: ["talk", "Are"],
      tip: "'Do you speak' for languages."
    },
    
    {
      type: "input",
      q: "Student: 'I'm from China. I speak ___.'",
      a: "Chinese",
      alts: ["chinese"],
      tip: "China → Chinese (language)."
    },
    
    {
      type: "mc",
      q: "Carlos says: 'I am from Mexico. I ___ Spanish.'",
      options: ["speak", "speaks", "speaking"],
      a: "speak",
      tip: "'I speak' (not 'I speaks')."
    },
    
    {
      type: "input",
      q: "Student from Germany: 'I speak German and ___.' (USA language)",
      a: "English",
      alts: ["english"],
      tip: "USA → English (most common language).",
      successTip: "USA has NO official language! But English is spoken by 80%+. Spanish is 2nd (40+ million speakers). Multilingual country! 🇺🇸"
    },
    
    {
      type: "order",
      q: "Traduce: 'Yo hablo inglés y español.'",
      words: ["I", "speak", "English", "and", "Spanish."],
      a: "I speak English and Spanish.",
      extra: ["talk", "the"],
      tip: "No article before languages ('the English' ❌).",
      successTip: "NO 'the' before languages! I speak THE English ❌. I speak English ✅. Simple rule! Same for all languages. 🌐"
    },
    
    {
      type: "mc",
      q: "Student: 'In Brazil, they speak ___.'",
      options: ["Portuguese", "Spanish", "Brazilian"],
      a: "Portuguese",
      tip: "Brazil speaks Portuguese, not Spanish!",
      successTip: "Brazil = Portuguese 🇧🇷 (NOT Spanish!). Portugal = Portuguese 🇵🇹. Only Portuguese-speaking country in South America! Common mistake! ⚠️"
    },
    
    {
      type: "input",
      q: "Question: 'What languages do you speak?' Answer: 'I speak Spanish ___ English.' (connector)",
      a: "and",
      tip: "'And' connects two languages."
    },
    
    {
      type: "match",
      q: "Match each language to a country where it's spoken.",
      pairs: [
        { left: "English", right: "Australia" },
        { left: "Spanish", right: "Argentina" },
        { left: "French", right: "Canada" }
      ],
      a: "completed",
      successTip: "Multiple countries share languages! English: USA, UK, Australia, Canada, etc. Spanish: Mexico, Spain, Argentina, etc. French: France, Canada, Belgium, etc. 🌍"
    }
  ]
},

// ===================================================================
// SET 6: FAMOUS PLACES (A1+)
// ===================================================================
{
  id: "u2-set6",
  title: "Set 6: Tourist Attractions",
  context: `*Tour Turístico - Londres*

Carlos visita lugares famosos con otros estudiantes.
"El Big Ben es británico," explica el guía.
"Y la Torre Eiffel es francesa," agrega un estudiante.

*Tourist Tour - London*

Carlos visits famous places with other students.
"Big Ben is British," explains the guide.
"And the Eiffel Tower is French," adds a student.`,
  
  questions: [
    {
      type: "match",
      q: "Match each landmark to its country.",
      pairs: [
        { left: "🗼 Eiffel Tower", right: "France" },
        { left: "🗽 Statue of Liberty", right: "USA" },
        { left: "🕰️ Big Ben", right: "UK" }
      ],
      a: "completed",
      tip: "Iconic landmarks.",
      successTip: "Tower = torre. Statue = estatua. Learn landmarks to describe countries! 'The Eiffel Tower is IN France' (location). 📍"
    },
    
    {
      type: "mc",
      q: "Guide: 'Sushi is ___ food.'",
      options: ["Japanese", "Japan", "from Japan"],
      a: "Japanese",
      tip: "Nationality works as adjective before nouns.",
      successTip: "Nationalities = adjectives! Japanese food 🍣, Italian pizza 🍕, French wine 🍷, Mexican tacos 🌮. Pattern: [Nationality] + [noun]. 🍴"
    },
    
    {
      type: "input",
      q: "Student: 'Pizza is ___ food.' (from Italy)",
      a: "Italian",
      alts: ["italian"],
      tip: "Italy → Italian (adjective)."
    },
    
    {
      type: "order",
      q: "Traduce: 'La comida mexicana es deliciosa.'",
      words: ["Mexican", "food", "is", "delicious."],
      a: "Mexican food is delicious.",
      extra: ["Mexico", "the"],
      tip: "Nationality + noun (Mexican food)."
    },
    
    {
      type: "mc",
      q: "Guide: 'This is a ___ restaurant.' (from China)",
      options: ["Chinese", "China", "from China"],
      a: "Chinese",
      tip: "Nationality as adjective."
    },
    
    {
      type: "input",
      q: "Student: 'I love ___ cars.' (from Germany)",
      a: "German",
      alts: ["german"],
      tip: "Germany → German (adjective)."
    },
    
    {
      type: "match",
      q: "Match each food to its country of origin.",
      pairs: [
        { left: "🌮 Tacos", right: "Mexico" },
        { left: "🍣 Sushi", right: "Japan" },
        { left: "🍕 Pizza", right: "Italy" }
      ],
      a: "completed",
      tip: "Famous foods."
    },
    
    {
      type: "mc",
      q: "Student: 'I want to buy a ___ watch.' (from Switzerland)",
      options: ["Swiss", "Switzerland", "Switz"],
      a: "Swiss",
      tip: "Switzerland → Swiss (adjective).",
      successTip: "Switzerland → Swiss. SHORT and easy! No -ish, -an, or -ese. Just 'Swiss' 🇨🇭. Swiss watches ⌚, Swiss chocolate 🍫, Swiss cheese 🧀. Quality! ✨"
    },
    
    {
      type: "input",
      q: "Guide: 'The Royal Family is ___.' (from UK)",
      a: "British",
      alts: ["british"],
      tip: "UK → British."
    },
    
    {
      type: "order",
      q: "Traduce: 'Me encanta la música española.'",
      words: ["I", "love", "Spanish", "music."],
      a: "I love Spanish music.",
      extra: ["Spain", "the"],
      tip: "No article before 'music' in general.",
      successTip: "'I love music' (general) ✅. 'I love THE music' (specific song/album) ✅. Context! Spanish music, French wine, Italian art - no 'the'! 🎵"
    }
  ]
},

// ===================================================================
// SET 7: AIRPORT PHRASES (A2-)
// ===================================================================
{
  id: "u2-set7",
  title: "Set 7: Helping at the Airport",
  context: `*Aeropuerto Heathrow - Salidas*

Carlos ayuda a un turista confundido en el aeropuerto.
"¿Dónde está mi puerta de embarque?" pregunta nervioso.
Carlos señala: "Gate 42, over there!"

*Heathrow Airport - Departures*

Carlos helps a confused tourist at the airport.
"Where is my boarding gate?" he asks nervously.
Carlos points: "Gate 42, over there!"`,
  
  questions: [
    {
      type: "mc",
      q: "Officer: '___ is your passport?'",
      options: ["Where", "What", "Who"],
      a: "Where",
      tip: "'Where' asks for location."
    },
    
    {
      type: "input",
      q: "Officer: 'Show me your ___.' (travel document)",
      a: "passport",
      alts: ["Passport"],
      tip: "Passport = pasaporte.",
      successTip: "Passport = travel ID 🛂. Valid for international travel. Check expiration date! Many countries need 6+ months validity. Important! ⚠️"
    },
    
    {
      type: "order",
      q: "Traduce la pregunta del oficial: '¿Cuál es tu nacionalidad?'",
      words: ["What", "is", "your", "nationality?"],
      a: "What is your nationality?",
      extra: ["Where", "country"],
      tip: "'What is your nationality?' = standard question."
    },
    
    {
      type: "mc",
      q: "Officer: 'Purpose of visit?' Tourist: 'I am on ___.'",
      options: ["vacation", "visiting", "tourist"],
      a: "vacation",
      tip: "'On vacation' = tourism.",
      successTip: "Purpose of visit answers: vacation 🏖️, business 💼, study 📚, visiting family 👨‍👩‍👧. Short answers work! Officer wants quick info. 🛂"
    },
    
    {
      type: "input",
      q: "Officer: 'Welcome to the UK!' Tourist: 'Thank ___!'",
      a: "you",
      tip: "'Thank you' = gracias."
    },
    
    {
      type: "order",
      q: "Traduce: 'Bienvenido a los Estados Unidos.'",
      words: ["Welcome", "to", "the", "USA."],
      a: "Welcome to the USA.",
      extra: ["America", "United"],
      tip: "'Welcome to' + country.",
      successTip: "'Welcome to [country]!' = standard greeting after immigration. Officers say this when you pass! 🎉 Response: 'Thank you!' 😊"
    },
    
    {
      type: "mc",
      q: "Tourist: 'Is this ___ bag?' 'Yes, it's mine.'",
      options: ["your", "you", "yours"],
      a: "your",
      tip: "'Your' before noun.",
      successTip: "'Your bag' (before noun) ✅. 'It's yours' (after verb) ✅. Possessive adjective vs pronoun! Grammar! 📚"
    },
    
    {
      type: "input",
      q: "Officer: 'Country of origin?' You answer: 'I am ___ Mexico.'",
      a: "from",
      tip: "Always 'from' before country."
    },
    
    {
      type: "mc",
      q: "Officer: 'How long is your stay?' Tourist: '___ two weeks.'",
      options: ["For", "In", "On"],
      a: "For",
      tip: "'For' + duration.",
      successTip: "'For' = duration! For two weeks, for 5 days, for 3 months. 'How long?' → 'For + time'. Common question! ⏱️"
    },
    
    {
      type: "match",
      q: "Match each airport question to its answer.",
      pairs: [
        { left: "Nationality?", right: "I am Mexican" },
        { left: "Purpose?", right: "Vacation" },
        { left: "How long?", right: "For 10 days" }
      ],
      a: "completed",
      successTip: "Immigration script! Nationality → origin. Purpose → why you visit. How long → duration. Know these = smooth entry! ✈️"
    }
  ]
},

// ===================================================================
// SET 8: SPELLING CHALLENGE (A2-)
// ===================================================================
{
  id: "u2-set8",
  title: "Set 8: Spelling Bee",
  context: `*Clase de Inglés - Competencia*

La profesora organiza una competencia de spelling.
"Spell 'Portuguese'!" dice la profesora.
Carlos respira hondo: "P-O-R-T-U-G-U-E-S-E!"

*English Class - Competition*

The teacher organizes a spelling competition.
"Spell 'Portuguese'!" says the teacher.
Carlos takes a deep breath: "P-O-R-T-U-G-U-E-S-E!"`,
  
  questions: [
    {
      type: "input",
      q: "Teacher: 'I'm from Lisbon, Portugal. I am ___.' (nationality)",
      a: "Portuguese",
      alts: ["portuguese"],
      tip: "Portugal → Portuguese (9 letters!).",
      successTip: "P-O-R-T-U-G-U-E-S-E. Longest common nationality! Same for language and nationality. 🇵🇹"
    },
    
    {
      type: "input",
      q: "Student: 'I'm from São Paulo, Brazil. I am ___.' (nationality)",
      a: "Brazilian",
      alts: ["brazilian"],
      tip: "Brazil → BraZILian (watch the 'z')."
    },
    
    {
      type: "mc",
      q: "Which spelling is CORRECT?",
      options: ["German", "Jerman", "Gherman"],
      a: "German",
      tip: "Germany → German (G not J).",
      successTip: "German starts with 'G' (not 'J')! Common mistake for Spanish speakers. 'J' sounds different in English! 🇩🇪"
    },
    
    {
      type: "input",
      q: "Student: 'I'm from Tokyo, Japan. I am ___.' (nationality)",
      a: "Japanese",
      alts: ["japanese"],
      tip: "Japan → Japanese (J-A-P-A-N-E-S-E)."
    },
    
    {
      type: "mc",
      q: "Which spelling is CORRECT?",
      options: ["British", "Brittish", "Britsh"],
      a: "British",
      tip: "Only one 't': B-R-I-T-I-S-H.",
      successTip: "British = one 't'! Common mistake: 'Brittish' ❌. Remember: Brit-ish (not Britt-ish). 🇬🇧"
    },
    
    {
      type: "input",
      q: "Student: 'I'm from Athens, Greece. I am ___.' (nationality)",
      a: "Greek",
      alts: ["greek"],
      tip: "Greece → Greek (short!).",
      successTip: "Greece → Greek. No -ian, -ish, or -ese! Just 'Greek'. Simple! 🇬🇷 Ancient Greeks invented democracy! 🏛️"
    },
    
    {
      type: "mc",
      q: "Which spelling is CORRECT?",
      options: ["French", "Franch", "Frensh"],
      a: "French",
      tip: "France → French (F-R-E-N-C-H)."
    },
    
    {
      type: "input",
      q: "Student: 'I'm from Warsaw, Poland. I am ___.' (nationality)",
      a: "Polish",
      alts: ["polish"],
      tip: "Poland → Polish (-ish ending)."
    },
    
    {
      type: "mc",
      q: "Which spelling is CORRECT?",
      options: ["Turkish", "Turkis", "Turkesh"],
      a: "Turkish",
      tip: "Turkey → Turkish (-ish ending).",
      successTip: "Turkey → Turkish. Same pattern as British, Polish, Spanish. -ish endings are common! 🇹🇷"
    },
    
    {
      type: "input",
      q: "Student: 'I'm from Amsterdam, Netherlands. I am ___.' (nationality)",
      a: "Dutch",
      alts: ["dutch"],
      tip: "Netherlands → Dutch (irregular!).",
      successTip: "Netherlands → Dutch. Weird! 😅 Not 'Netherlandish' ❌. Holland = informal name for Netherlands. 'I'm Dutch' = 'I'm from Holland/Netherlands'. 🇳🇱"
    }
  ]
},

// ===================================================================
// SET 9: CULTURAL SYMBOLS (A2-)
// ===================================================================
{
  id: "u2-set9",
  title: "Set 9: Culture Quiz",
  context: `*Clase de Inglés - Quiz Cultural*

La profesora muestra banderas y símbolos de países.
"¿De qué país es el maple leaf?" pregunta.
Carlos levanta la mano: "Canada!"

*English Class - Culture Quiz*

The teacher shows flags and symbols of countries.
"Which country has the maple leaf?" she asks.
Carlos raises his hand: "Canada!"`,
  
  questions: [
    {
      type: "mc",
      q: "Quiz: 'Which country has kangaroos 🦘 and koalas 🐨?'",
      options: ["Australia", "Austria", "New Zealand"],
      a: "Australia",
      tip: "Don't confuse Australia (Oceania) with Austria (Europe)!",
      successTip: "Australia 🇦🇺 = kangaroos, koalas. Austria 🇦🇹 = Alps, Mozart. VERY different! Common confusion! 😅"
    },
    
    {
      type: "mc",
      q: "Quiz: 'Which country is famous for tango 💃?'",
      options: ["Argentina", "Spain", "Mexico"],
      a: "Argentina",
      tip: "Tango originated in Argentina."
    },
    
    {
      type: "input",
      q: "Quiz: 'The Eiffel Tower is in ___.' (country)",
      a: "France",
      alts: ["france"],
      tip: "Eiffel Tower = Paris, France."
    },
    
    {
      type: "match",
      q: "Match each flag symbol to its country.",
      pairs: [
        { left: "🍁 Maple Leaf", right: "Canada" },
        { left: "⭐ 50 Stars", right: "USA" },
        { left: "☀️ Sun", right: "Japan" }
      ],
      a: "completed",
      tip: "National symbols on flags.",
      successTip: "Flags tell stories! 🍁 Canada's maple syrup, ⭐ USA's 50 states, ☀️ Japan's rising sun. Learn symbols = easy to remember! 🏳️"
    },
    
    {
      type: "mc",
      q: "Quiz: 'Which country invented pizza 🍕?'",
      options: ["Italy", "USA", "Greece"],
      a: "Italy",
      tip: "Pizza is Italian food."
    },
    
    {
      type: "input",
      q: "Quiz: 'The Great Wall is in ___.' (country)",
      a: "China",
      alts: ["china"],
      tip: "Great Wall of China = famous landmark."
    },
    
    {
      type: "mc",
      q: "Quiz: 'Which country has pyramids 🔺?'",
      options: ["Egypt", "Mexico", "Both A and B"],
      a: "Both A and B",
      tip: "Both Egypt and Mexico have pyramids!",
      successTip: "Egypt 🇪🇬 = ancient pyramids (Giza). Mexico 🇲🇽 = Mayan/Aztec pyramids (Chichen Itza). Different cultures, same shape! 🔺"
    },
    
    {
      type: "input",
      q: "Quiz: 'Flamenco dancing is from ___.' (country)",
      a: "Spain",
      alts: ["spain"],
      tip: "Flamenco = Spanish dance."
    },
    
    {
      type: "mc",
      q: "Quiz: 'Which country has the Amazon rainforest 🌳?'",
      options: ["Brazil", "Mexico", "Colombia"],
      a: "Brazil",
      tip: "Amazon = mostly in Brazil."
    },
    
    {
      type: "match",
      q: "Match each famous person to their nationality.",
      pairs: [
        { left: "Shakespeare", right: "British" },
        { left: "Picasso", right: "Spanish" },
        { left: "Einstein", right: "German" }
      ],
      a: "completed",
      successTip: "Famous people help learn nationalities! Shakespeare 🇬🇧, Picasso 🇪🇸, Einstein 🇩🇪. Culture + English = fun learning! 📚"
    }
  ]
},

// ===================================================================
// SET 10: WORLD CITIZEN (A2-)
// ===================================================================
{
  id: "u2-set10",
  title: "Set 10: Final Presentations",
  context: `*Ceremonia de Graduación - Escuela*

Carlos presenta frente a toda la clase.
"I am from Mexico. I am Mexican. I speak Spanish and English!"
Todos aplauden. Carlos sonríe orgulloso.

*Graduation Ceremony - School*

Carlos presents in front of the whole class.
"I am from Mexico. I am Mexican. I speak Spanish and English!"
Everyone applauds. Carlos smiles proudly.`,
  
  questions: [
    {
      type: "order",
      q: "Traduce la presentación de Carlos: 'Soy de México y soy mexicano.'",
      words: ["I", "am", "from", "Mexico", "and", "I", "am", "Mexican."],
      a: "I am from Mexico and I am Mexican.",
      extra: ["the", "speak"],
      tip: "Combine origin + nationality with 'and'.",
      successTip: "Perfect introduction formula: I am from [country] and I am [nationality]. Add 'I speak [language]' = complete! 🎓"
    },
    
    {
      type: "mc",
      q: "Student: 'I am ___ Germany. I am German. I speak German.'",
      options: ["from", "in", "of"],
      a: "from",
      tip: "Origin needs 'from'."
    },
    
    {
      type: "input",
      q: "Student: 'I am from Japan. I am ___. I speak Japanese.'",
      a: "Japanese",
      alts: ["japanese"],
      tip: "Japan → Japanese (nationality and language)."
    },
    
    {
      type: "match",
      q: "Match each complete introduction to its country.",
      pairs: [
        { left: "I'm French. I speak French.", right: "France" },
        { left: "I'm Chinese. I speak Chinese.", right: "China" },
        { left: "I'm Brazilian. I speak Portuguese.", right: "Brazil" }
      ],
      a: "completed",
      tip: "Notice Brazil speaks Portuguese!",
      successTip: "Brazil trick question! Brazilian speaks Portuguese (not Spanish). Only one! 🇧🇷 Master this = impress natives! 💡"
    },
    
    {
      type: "input",
      q: "Student: 'I'm from Italy. I'm Italian. I speak ___.'",
      a: "Italian",
      alts: ["italian"],
      tip: "Italy → Italian (language)."
    },
    
    {
      type: "order",
      q: "Traduce: 'Ella es de España y habla español e inglés.'",
      words: ["She", "is", "from", "Spain", "and", "speaks", "Spanish", "and", "English."],
      a: "She is from Spain and speaks Spanish and English.",
      extra: ["the", "she"],
      tip: "'Speaks' with 'she' (add -s)."
    },
    
    {
      type: "mc",
      q: "Complete: 'We are from Canada. We are Canadian. We speak English ___ French.'",
      options: ["and", "or", "with"],
      a: "and",
      tip: "'And' connects two languages.",
      successTip: "Canada = bilingual! 🇨🇦 English AND French (official languages). Quebec speaks French, rest mostly English. Two languages = cool! 🗣️"
    },
    
    {
      type: "input",
      q: "Question: 'Where are you from, what's your nationality, and what language do you speak?' You: 'I'm ___ Mexico, I'm Mexican, and I speak Spanish.'",
      a: "from",
      tip: "Origin needs 'from'."
    },
    
    {
      type: "mc",
      q: "Student: 'I am American. I am ___ the USA.'",
      options: ["from", "in", "at"],
      a: "from",
      tip: "Always 'from' for origin."
    },
    
    {
      type: "match",
      q: "Match each question to the information it asks for.",
      pairs: [
        { left: "Where are you from?", right: "Country/Origin" },
        { left: "What's your nationality?", right: "Identity/Adjective" },
        { left: "What languages do you speak?", right: "Communication" }
      ],
      a: "completed",
      successTip: "Three pillars of introductions! 🏛️ Origin (where), Identity (who), Communication (how). Master these = international citizen! 🌍 Ready for Unit 3! 🚀"}
      ]
    }
  ],   

readingSet: {
    id: "u2-reading",
    title: "Set 12: Review & Mastery",  
  questions: [
    {
      type: "passage",
      passage: `**International Student Meeting**

Today is the first day at London Language School. Students from 12 countries meet in the cafeteria. The teacher, Ms. Brown, asks everyone to introduce themselves.

"Hello! I'm Carlos. I'm from Mexico, so I'm Mexican. I speak Spanish and I'm learning English," says Carlos.`
    },
    
    {
      type: "mc",
      q: "Where is Carlos from?",
      options: ["Mexico", "Spain", "London"],
      a: "Mexico",
      tip: "Look at Carlos's introduction."
    },
    
    {
      type: "mc",
      q: "What is Carlos's nationality?",
      options: ["Mexican", "Spanish", "American"],
      a: "Mexican",
      tip: "He says 'I'm Mexican'."
    },
    
    {
      type: "mc",
      q: "How many countries are represented?",
      options: ["12", "10", "15"],
      a: "12",
      tip: "First paragraph: 'students from 12 countries'."
    },
    
    {
      type: "passage",
      passage: `"Hi everyone! My name is Yuki. I'm from Tokyo, Japan, so I'm Japanese. I speak Japanese and English," says a student with a smile.

"Bonjour! I'm Marie. I'm French. I'm from Paris, France. I speak French and a little English," says another student.`
    },
    
    {
      type: "mc",
      q: "What language does Yuki speak?",
      options: ["Japanese and English", "Only Japanese", "French and English"],
      a: "Japanese and English",
      tip: "Yuki says 'I speak Japanese and English'."
    },
    
    {
      type: "input",
      q: "Marie is from ___. (city)",
      a: "Paris",
      alts: ["paris"],
      tip: "Marie says 'I'm from Paris, France'."
    },
    
    {
      type: "mc",
      q: "Marie speaks English very well.",
      options: ["False", "True"],
      a: "False",
      tip: "She says 'a little English' (not very well).",
      successTip: "'A little' = not much. 'Very well' = proficient. Reading comprehension = exact words! 📖"
    },
    
    {
      type: "passage",
      passage: `"Hello! I'm Ahmed. I'm from Cairo, Egypt. I'm Egyptian. I speak Arabic and English," says a tall student.

Ms. Brown smiles. "Wonderful! We have students from Mexico, Japan, France, and Egypt today. Let's learn English together!"

All the students are excited to start their classes.`
    },
    
    {
      type: "mc",
      q: "Ahmed is from which country?",
      options: ["Egypt", "Arabia", "Cairo"],
      a: "Egypt",
      tip: "Ahmed says 'I'm from Cairo, Egypt'."
    },
    
    {
      type: "input",
      q: "Ahmed speaks Arabic and ___.",
      a: "English",
      alts: ["english"],
      tip: "He says 'I speak Arabic and English'."
    },
    
    {
      type: "mc",
      q: "How do the students feel about starting classes?",
      options: ["Excited", "Nervous", "Bored"],
      a: "Excited",
      tip: "Last line: 'All the students are excited'.",
      successTip: "Reading = find exact info! Don't assume. Last sentence tells emotion: 'excited'. Always check text! ✅"
    }
  ]
},

// ===================================================================
// SET 12: REVIEW (A2)
// ===================================================================
  reviewSet: {
    id: "u2-review",
    title: "Set 12: Review & Mastery",
    questions: [
    {
      type: "match",
      q: "Review: Match countries to nationalities.",
      pairs: [
        { left: "USA", right: "American" },
        { left: "Spain", right: "Spanish" },
        { left: "Japan", right: "Japanese" },
        { left: "Brazil", right: "Brazilian" }
      ],
      a: "completed",
      tip: "Review all patterns."
    },
    
    {
      type: "mc",
      q: "Review: Which is CORRECT?",
      options: ["I am from France", "I am from French", "I am of France"],
      a: "I am from France",
      tip: "'From' + country (not nationality)."
    },
    
    {
      type: "mc",
      q: "Review: Which is CORRECT?",
      options: ["I am Mexican", "I am from Mexican", "I am a Mexican"],
      a: "I am Mexican",
      tip: "Nationality doesn't need 'from' or article."
    },
    
    {
      type: "order",
      q: "Review: Traduce: '¿De dónde eres?'",
      words: ["Where", "are", "you", "from?"],
      a: "Where are you from?",
      extra: ["What", "country"],
      tip: "Standard question for origin."
    },
    
    {
      type: "input",
      q: "Review: 'I'm from Germany, so I'm ___.'",
      a: "German",
      alts: ["german"],
      tip: "Germany → German."
    },
    
    {
      type: "mc",
      q: "Review: 'Do you ___ English?'",
      options: ["speak", "talk", "say"],
      a: "speak",
      tip: "'Speak' for languages."
    },
    
    {
      type: "input",
      q: "Review: 'I am from China. I speak ___.'",
      a: "Chinese",
      alts: ["chinese"],
      tip: "China → Chinese (language)."
    },
    
    {
      type: "mc",
      q: "Review: 'Pizza is ___ food.'",
      options: ["Italian", "Italy", "from Italy"],
      a: "Italian",
      tip: "Nationality as adjective."
    },
    
    {
      type: "match",
      q: "Review: Match questions to answers.",
      pairs: [
        { left: "Where are you from?", right: "I'm from Canada" },
        { left: "What's your nationality?", right: "I'm Canadian" },
        { left: "Do you speak French?", right: "Yes, I do" }
      ],
      a: "completed",
      tip: "Three key questions."
    },
    
    {
      type: "order",
      q: "Review: Traduce: 'Soy de México y hablo español.'",
      words: ["I", "am", "from", "Mexico", "and", "I", "speak", "Spanish."],
      a: "I am from Mexico and I speak Spanish.",
      extra: ["the", "Mexican"],
      tip: "Combine origin + language.",
      successTip: "🎉 UNIT 2 COMPLETE! You can now introduce yourself internationally! Next: Unit 3 - Ages & Numbers! 🚀"
    }
  ]
}
};
